<script>
import fileHelper from "@/mixins/fileHelper.js";

export default {
  mixins: [
    fileHelper
  ],
  props: {
    fileAllowedExtensions: {
      type: String,
      required: false,
      default: 'jpg jpeg png gif pdf doc docx xls xlsx ppt pptx zip'
    },
    fileMaxSize: {
      type: Number,
      required: false,
      default: 1024 * 1024 * 10
    },
  },
}
</script>

<template>
  <p class="mt-1 text-sm leading-6 text-gray-500">
    Het is mogelijk om meerdere bestanden te selecteren.<br>
    Toegestane bestandstypes: {{ fileAllowedExtensions }}.<br>
    Maximale bestandsgrootte: {{ formatSize(fileMaxSize) }}
  </p>
</template>
